import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RXOpt, RXOptValue } from "../../models/order.model";
import { SharedService } from "../../services/shared.service";
import { AuthService } from "../../services/auth.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { ClearMultiComponent } from "../ui/clear-multi.component";
import { InputWrapComponent } from "../ui/input-wrap.component";
import { CheckboxWrapComponent } from "../ui/checkbox-wrap.component";
import { FormsModule } from "@angular/forms";
import { SvgIconComponent } from "angular-svg-icon";
import { TooltipModule } from "primeng/tooltip";
import { RadioButtonModule } from "primeng/radiobutton";
import { SelectButtonModule } from "primeng/selectbutton";

@Component({
  selector: "rx-opt-display",
  templateUrl: "./rx-opt-display.component.html",
  styleUrls: ["./rx-opt-display.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    SelectModule,
    ClearMultiComponent,
    InputWrapComponent,
    CheckboxWrapComponent,
    FormsModule,
    SvgIconComponent,
    TooltipModule,
    RadioButtonModule,
    SelectButtonModule,
    TranslateModule,
  ],
})
export class RxOptDisplayComponent {
  @Input() opt: RXOpt;
  @Input() label: boolean = true;
  @Input() singleLine: boolean;
  @Input() readOnly: boolean;
  @Input() drProfileSw: boolean;

  @Output() onOptValueChange = new EventEmitter<RXOptValue | undefined>();

  valueValid: boolean = true;
  validationMsg: string;

  constructor(
    private translateService: TranslateService,
    private sharedService: SharedService
  ) { }

  onListValueChanged() {
    this.onOptValueChange.emit(this.opt.selectedValue);
  }

  onChange() {
    this.onOptValueChange.emit(undefined);
  }

  getIcon(key: string) {
    return "/assets/img/rx_icons/" + key;
    //return this.authService.assetsUrl + "/assets/rx_icons/" + key;
  }

  allowDropdownCustomInput() {
    return (this.opt.id as string).includes("SHADE");
  }

  validateTextInput(event: KeyboardEvent) {
    if (
      this.opt.id == "CAST_CLASP" ||
      this.opt.id == "WIRE_CLASP" ||
      this.opt.id == "VALPLAST_CLASP"
    ) {
      let validationResult = this.sharedService.getTeethValidityCode(
        this.opt.valueText
      );
      this.valueValid = validationResult[0] == 0;
      if (!this.valueValid) {
        this.validationMsg = this.translateService.instant(
          "translate.validation.teethInput_" + validationResult[0]
        );
      } else {
        this.validationMsg = null;
      }
    }
  }
}
